export default Object.freeze({
  GUTTER: 'GUTTER',
  FIXED_CONTENTION: 'FIXED_CONTENTION',
  REMOVABLE_CONTENTION: 'REMOVABLE_CONTENTION',
});
